export default {
  setNotifications (state, notifications) {
    state.notifications = notifications
  }
}
